import { useContext } from 'react'
import { ScrollablesContext } from './scrollables-context'

export default function useFormScrollables() {
  return useContext(ScrollablesContext)
}
